export default "__VITE_ASSET__6473ae40__"